import { LocalNotFoundError } from '../general.errors';

export class SceneNotFoundError extends LocalNotFoundError {
    constructor(message: string) {
        super(message);
        this.name = 'SceneNotFoundError';
    }
}
